import { useContext, useMemo } from "react";
import { Button, Nav } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";

import { faChevronRight, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { RouteSettingType, blockedOrgsFromBlast } from "../../constants";
import { UserDataContext } from "../../contexts/userDataContext";
import { isBlast } from "../../utils";
import { Footer } from "../footer";
import { SideNavSection, isBlockedOrg, isSameOrg } from "./sideNavSection";

export const Sidebar = ({
	show,
	setShow,
	navSettings,
	bottomNavSettings = [],
}: {
	show: boolean;
	setShow: (x: boolean) => void;
	navSettings: any;
	bottomNavSettings?: any;
}) => {
	const { selectedOrg } = useContext(UserDataContext);

	const showClass = show ? "show" : "";
	const onCollapse = () => setShow(!show);

	const navSections = useMemo(
		() =>
			isBlast &&
			(isSameOrg(blockedOrgsFromBlast, selectedOrg.id) ||
				isBlockedOrg(selectedOrg))
				? null
				: navSettings.map(
						(navSection: RouteSettingType, index: number) => (
							<SideNavSection
								key={`side-nav-${index}`}
								setShow={setShow}
								{...navSection}
								divider={index > 0}
							/>
						)
				  ),
		[navSettings, setShow]
	);
	const bottomNavSections = useMemo(
		() =>
			bottomNavSettings.map(
				(navSection: RouteSettingType, index: number) => (
					<SideNavSection
						key={`bottom-side-nav-${index}`}
						setShow={setShow}
						{...navSection}
						divider={index > 0}
					/>
				)
			),
		[bottomNavSettings, setShow]
	);

	return (
		<>
			<div className="collapse show sidebar sidebar-collapsed d-none d-md-block bg-charcoal text-white mt-nav">
				<div className="sidebar-inner pt-3">
					<Nav className="flex-column mt-1 pt-3 pt-md-0">
						<Button
							className="btn btn-charcoal collapse-button expand-button"
							onClick={onCollapse}
						>
							<FontAwesomeIcon icon={faChevronRight} />
						</Button>
						<div className="mt-0">{navSections}</div>
					</Nav>
				</div>
			</div>
			<CSSTransition
				timeout={300}
				in={show}
				classNames="sidebar-transition"
			>
				<div
					className={`collapse sidebar ${showClass} bg-charcoal text-white mt-nav`}
				>
					<div className="sidebar-inner px-0 pt-2">
						<Nav className="flex-column mt-1 pt-3 pt-md-0">
							<Button
								className="btn btn-charcoal collapse-button"
								onClick={onCollapse}
							>
								<FontAwesomeIcon
									className="d-none d-md-block"
									icon={faTimes}
								/>
								<FontAwesomeIcon
									className="d-block d-md-none"
									icon={faTimes}
								/>
							</Button>
							<div className="mt-0">{navSections}</div>
						</Nav>
					</div>
					<div className="bottom-nav-section">
						{bottomNavSections}
					</div>
					<Footer />
				</div>
			</CSSTransition>
		</>
	);
};
